import React, { useContext, useState } from "react"
import useSWR from "swr"
import Fade from "@material-ui/core/Fade"
import Cookie from "js-cookie"

/** Service */
import vmsAPI from "services/Dashboard/VMS"
/** Components */
import Table from "components/Table"
import Loader from "components/Loader"
import { Context } from "context/Dashboard/VMS/categories/main/Context"
import tableHeaders from "./table/tableHeaders"
/** Context */

interface TableServiceProvidersProps {
  activeFilter: number
}

const TableAll: React.FC<TableServiceProvidersProps> = () => {
  const { setDownloadData } = useContext(Context)
  const [currentPage, setCurrentPage] = useState(0)

  const fetchAllVMS = async () =>
    vmsAPI.getVMS({
      "condo_uid": Cookie.get("condoUID")
    })

  const { data, isValidating } = useSWR("fetchAllVMS", fetchAllVMS, {
    revalidateOnFocus: true
  })
  const tableData = data?.data?._data

  if (isValidating) {
    return <Loader dark />
  }

  return (
    <Fade in={!isValidating}>
      <div>
        <Table
          data={tableData || []}
          columns={tableHeaders(`fetchAllVMS`)}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isFilterable
          action={(values: any) => {
            return (
              setDownloadData &&
              setDownloadData(
                values?.map((i: any) => {
                  return {
                    "Status": i?.status,
                    "Category": i?.category,
                    "Block/Unit No.": i?.blockUnitNo,
                    "Name": i?.name,
                    "Mobile": i?.mobile,
                    "Email": i?.email,
                    "Purpose": i?.purpose,
                    "Start Date": i?.startDate,
                    "End Date": i?.endDate,
                    "Multiple Visitors": i?.multipleVisitors,
                    "Visitors Count": i?.visitorsCount,
                    "Visitation Date": i?.visitationDate,
                    "Visitation Time": i?.visitationTime,
                    "Resident Name": i?.residentName,
                    "Remarks": i?.remarks,
                    "OTP": i?.otp
                  }
                })
              )
            )
          }}
        />
      </div>
    </Fade>
  )
}

export default TableAll
